import { HtmlHTMLAttributes } from 'react'
import './Tooltip.css'

interface Props extends HtmlHTMLAttributes<HTMLDivElement> {
  text: string
  position?: 'bottom' | 'left' | 'top'
}

function Tooltip({
  text,
  className,
  position = undefined,
  style,
  ...rest
}: Props) {
  const classes = `Tooltip__tooltip ${
    position ? `Tooltip__tooltip--${position}` : ''
  } ${className || ''}`

  return (
    <div className={classes} style={style} {...rest}>
      {text}
    </div>
  )
}

export default Tooltip
